import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { formGroupNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { SystemTablesService } from '../services/system-tables.service';

@Component({
  selector: 'app-add-liability',
  templateUrl: './add-liability.component.html',
  styleUrls: ['./add-liability.component.scss']
})
export class AddLiabilityComponent implements OnInit {
	@Input() qID: number = null;
	@Input() public index: number;
	@Input() public liability: FormGroup;
	@Output() public removed: EventEmitter<number> = new EventEmitter<number>();
	@Input() public displayErrors: boolean;
	@Input() public displayX: boolean;
	@Input() types: string[];
	defaultValue = "";
	
	  constructor() { }

  ngOnInit() {
  }

  static buildLiability(val: any) {
		let flag:boolean = false;

		if (val) {
			if (val[0].answerValue === "מזונות" || val[0].answerValue === "שכר דירה") {
				flag = true;
			}
		}
		//value equal to val if val exist else equal to "", disabled equal to true if val exist and equal to mezonot or Rent else equal to false 
    let fg:FormGroup =  new FormGroup({
		liabilityType: new FormControl({value:val? val[0].answerValue : "", disabled: flag}),
		liabilityBalance: new FormControl(val? val[1].answerValue : ""),
		liabilityMonthlyRefund: new FormControl(val? val[2].answerValue : ""),
		liabilityEndDate: new FormControl(val? val[3].answerValue : ""),
		required: new FormControl(val? val.required : false)
	});
	//if(flag){fg.setValue({display:flag});}
	

	return fg;
	// return new FormGroup({
	// 	liabilityType: new FormControl(val? val.liabilityType : "", Validators.required),
	// 	liabilityBalance: new FormControl(val? val.liabilityBalance : "", Validators.required),
	// 	liabilityMonthlyRefund: new FormControl(val? val.liabilityMonthlyRefund : "", Validators.required),
	// 	liabilityEndDate: new FormControl(val? val.liabilityEndDate : "", Validators.required)
	// });
  }
}



// WEBPACK FOOTER //
// ./src/app/add-liability/add-liability.component.ts